<mat-toolbar cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle *ngIf="this.isPopUp" class="mat-accent m-0">
  <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <span class="title dialog-title">{{ "POPUPHEADER" | translate }}</span>
    <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div id='content'>

  <!-- TO DO: this kanban component is never used remove or change with custom kanban -->
  <!-- <daypilot-kanban #kanbanBoard [config]="config"></daypilot-kanban> -->

</div>
